import { format } from 'date-fns';
import { LoadTrackAndTraceData, LoadTrackAndTraceDataUsingClientCodeAndState } from '../Service';
import { isNil } from 'lodash';


export class UtilsService {
    
    stateAbbrevToStateId(stateAbbrev) {
        var stateId = 0;
    
        switch (stateAbbrev) {
            case 'M':
                stateId = 1;
                break;
            case 'S':
                stateId = 2;
                break;
            case 'B':
                stateId = 3;
                break;
            case 'A':
                stateId = 4;
                break;
            case 'P':
                stateId = 5;
                break;
            case "VIC":
                stateId = 1;
                break;
            case "NSW":
                stateId = 2;
                break;
            case "QLD":
                stateId = 3;
                break;
            case "SA":
                stateId = 4;
                break;
            case "WA":
                stateId = 5;
                break;
        }
    
        return stateId;    
    }


    stateIdToState(id) {
        let state = null;
        
        switch(id) {
            case 1:
                state = 'VIC';
            break;
            case 2:
                state = 'NSW';
            break;
            case 3:
                state = 'QLD';
            break;
            case 4:
                state = 'SA';
            break;
            case 5:
                state = 'WA';
            break;
        }

        return state;
    }


    /**
     * Returns the lat and lng coordinates that represents the center of the state provided.
     */
    stateCenterCoordinates(stateId) {
        let stateCoordinates = {};
        
        switch(stateId) {
            case 1 : /* VIC */ 
                stateCoordinates = { lat: -37.8136, lng: 144.9631 }
            break;
            case 2 : /* NSW */
                stateCoordinates = { lat: -33.8688, lng: 151.2093 }
            break;
            case 3 : /* QLD */
                stateCoordinates = { lat: -27.4698, lng: 153.0251 }
            break;
            case 4 : /* SA */
                stateCoordinates = { lat: -34.9285, lng: 138.6007 }
            break;
            case 5 : /* WA */
                stateCoordinates = { lat: -31.9505, lng: 115.8605 }
            break;
        }

        return stateCoordinates;
    }


    /**
     * Returns the name/word representation of a JobEventEnum value
     */
    jobEventEnumName(jobEventEnum) {
        let name = '';

        switch (jobEventEnum) {
            case 0:
                name = 'Job Booked';
            break;
            case 1:
                name = 'Job Update';
            break;
            case 2:
                name = 'Pending Pickup';
            break;
            case 3:
                name = 'Pickup Arrived';
            break;
            case 4:
                name = 'Pickup Completed';
            break;
            case 5:
                name = 'Delivery Arrived';
            break;
            case 6:
                name = 'Delivery Completed';
            break;
            case 7:
                name = 'Cancelled';
            break;
            case 8:
                name = 'Completed';
            break;
            case 9:
                name = 'GPS';
                break;
            case 10:
                name = 'LegArrive'
                break;
            case 11:
                name = 'Logon';
                break;
            case 12:
                name = 'Job Accepted';
                break;
            case 13:
                name = 'Allocated';
                break;
            case 14:
                name = 'Accepted';
                break;
            case 15:
                name = 'Arrive';
                break;
            case 16:
                name = 'Depart';
                break;
            case 17:
                name = 'Complete';
                break;
            case 18:
                name = 'Pickup Allocated';
                break;
            case 19:
                name = 'Pickup Accepted';
                break;
            case 20:
                name = 'Arrive @Pickup';
                break;
            case 21:
                name = 'Pickup Completed';
                break;
            case 22:
                name = 'Arrive @Delivery';
                break;
            case 23:
                name = 'Delivery Completed';
                break;    
        }

        return name;
    }


    /**
     * Format the provided date into our "default human readable" format which looks like "22 Jan 2025 12:19:41".
     * @param date: DateTime;
     * @param options 
     * {
     *   dateOnly: boolean; Whether we show date only without time.
     *   timeOnly: boolean; Whether we show the time value only.
     * }
     */
    formatDateTime(date, options = null) {
        if(!date) {
            return '';
        }
        
        const dateObject = new Date(date);

        if(options?.timeOnly) {
            return format(dateObject, 'HH:mm:ss');
        } else if(options?.dateOnly) {
            return format(dateObject, 'dd MMM yyyy');
        } else {
            return format(dateObject, 'dd MMM yyyy HH:mm:ss');
        }
    }


    /**
     * Loads the track and trace data then opens the job tracking page
     */
    openJobTrackingPage(jobNumber, accountcode,stateid, subJobNumber,userInfo) {
        LoadTrackAndTraceDataUsingClientCodeAndState(jobNumber,accountcode,stateid, userInfo,subJobNumber)
        .then((data) => {
            window.open(data, '_blank');
        })
        .catch((error) => { console.error("Failed!", error); });
    }

    openJobTrackingPageUsingClientCodeAndState(jobNumber, clientCode, stateAbbrev, userInfo, subJobId) {
        LoadTrackAndTraceDataUsingClientCodeAndState(jobNumber, clientCode, this.stateAbbrevToStateId(stateAbbrev), userInfo, subJobId)
        .then((data) => {
            window.open(data, '_blank');
        })
            .catch((error) => { console.error("Failed!", error); });
    }

    downloadFile(details, legs, legnumber, driver) {
        let vals = {
            Details: details,
            Legs: legs,
            Legnumber: legnumber,
            Driver: {Id: driver.id}
            
        };
        let today = new Date();
        let time = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + today.getMinutes() + today.getSeconds();
        let fileName = 'POD_' + details.id +'_' + time + '.pdf';
        return fetch('api/ExportPod/ExportPDF', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(vals)
        })
        .then((response) => response.blob())
        .then((blob) => {
            console.log(blob);
            
            // Create blob link to download
            const url = window.URL.createObjectURL(
                new Blob([blob]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                fileName,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        });
    }


    /**
     * Determines if the provided clientCode is one of the Sigma accounts.
     */
    isClientCodeSigmaRelated(clientCode) {
        const sigmaCodes = [
            '3SIGAD',
            '3SIGBAL',
            '3SIGDAN',
            '3SIGMA',
            '3SIGMAP',
            '3SIGMATE',
            '3SIGTOOL',
            '3SPACBE',
            '83SIGMA',
            '9ELSIGMA',
            '9SIGMA',
            'KASIGADD',
            'KASIGMAS',
            'KASIGPHA',
            'KASIGPJS',
            'KASIGSS',
            'KBSIGADH',
            'KBSIGMA',
            'KBSIGMAM',
            'KBSIGMAS',
            'KBSIGMAT',
            'KBSIGMAW',
            'KBSIGPJQ',
            'KDSIGMA',
            'KDSIGMAA',
            'KMSIGLAH',
            'KMSIGLMC',
            'KMSIGMA',
            'KMSIGOPS',
            'KMSIGPJV',
            'KMSIGSAT',
            'KMSIGTRU',
            'KMSIGWHS',
            'KPSIGADH',
            'KPSIGPAR',
            'KPSIGPJW',
            'KPSIGPRM',
            'KPSIGPRS',
            'KPSIGSUP',
            'KPSIGWAT',
            'KSSIGM',
            'KSSIGMA',
            'KSSIGMM',
            'KSSIGMR',
            'KSSIGMS',
            'KSSIGMT',
            'KSSIGPJN',
            'SIGCOM',
            'SIGMA',
            'SIGMA',
            'SIGMAHEA',
            'SIGPERM',
            'SIGPRJN',
            'SIGPRJQ',
            'KMCW',
            'KSCW',
            'KBCW',
            'KPCW',
            'KACW'
        ];
        
        if(sigmaCodes.includes(clientCode?.toUpperCase())) {
            return true;
        } else {
            return false;
        }
    }


    /**
     * Checks if a latLng location is valid or not.
     * Returns true if valid.
     * Latitude must be between -90 and 90
     * Longitude must be between -180 and 180
     * Lat: 0 and Lng: 0 is considered invalid
     * Invalid if either lat or lng is null/undefined
     */
    isLocationValid(lat, lng) {
        if(isNil(lat) || isNil(lng)) {
            return false;
        }

        else if(lat === 0 && lng === 0) {
            return false;
        }
        
        else if(lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
            return true;
        }

        else {
            return false;
        }
    }
    
}